import {useNavigate} from "react-router-dom";

export default function NotFound(){
    const navigate = useNavigate();

    return (
        <div
            className="min-h-screen flex flex-col items-center justify-center text-center p-6 bg-transparent text-white">
            <h1 className="text-6xl font-extrabold text-primary mb-4">404</h1>
            <p className="text-2xl font-semibold mb-2">Oops! This page took a vacation 🏖️</p>
            <p className="mb-6 max-w-xl">
                We looked everywhere, even behind the fridge and under the couch cushions, but we couldn’t find the page
                you were looking for.
            </p>
            <img
                src="https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExbHU2MXhlajNpOW9jZ3NyYTU4NGpyajBkdmlhcmEzMGVodzVlb21mYSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/S7u66urzxc2J2/giphy.gif"
                alt="Funny confused gif"
                className="w-80 h-80 object-contain mb-6"
            />
            <button
                onClick={() => navigate("/")}
                className="bg-primary hover:bg-primary/80 text-white px-6 py-2 rounded-full shadow-lg"
            >
                Take Me Home 🏠
            </button>
        </div>
    );
}